import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { UFCEvent, QueryResult } from '../types';

export function useUFCFightCard(): QueryResult<UFCEvent[]> {
  const { client } = useDubs();
  const [data, setData] = useState<UFCEvent[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await client.getUFCFightCard();
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
